import { ComponentType, useRef } from 'react';
import { Col } from 'react-bootstrap';
import { TextArea, TextAreaProps } from '@progress/kendo-react-inputs';
import { Label, Error } from '@progress/kendo-react-labels';

interface StandardTextareaProps extends TextAreaProps {
  label?: string;
  labelStyle?: string;
  colSize?: number | undefined;
}

export const StandardTextarea: ComponentType<StandardTextareaProps> = ({
  label,
  colSize,
  labelStyle,
  ...props
}) => {
  const inputRef = useRef(null);
  return (
    <Col sm={12} md={colSize ?? 12}>
      <Label className={labelStyle} editorRef={inputRef}>
        {label}
      </Label>
      <TextArea ref={inputRef} {...props} />
      {props?.validationMessage !== '' && (
        <Error>{props?.validationMessage}</Error>
      )}
    </Col>
  );
};

export default StandardTextarea;
